'use client';

import { useRef } from 'react';
import { Transition, TransitionStatus } from 'react-transition-group';
import { useUnit } from 'effector-react';
import { $SearchStore, closeSearchEvent } from '@nx-frontend/shared/store/search';
import { SearchModalWrapper } from './search-modal';

const transitionClasses = {
  entering: 'opacity-1',
  entered: 'opacity-1',
  exiting: 'opacity-0',
  exited: 'opacity-0',
  unmounted: 'opacity-0',
};

export const SearchLayout = ({
  onClose,
  animate,
}: {
  children?: React.ReactNode;
  onClose?: () => void;
  animate?: boolean;
}) => {
  const [store, closeModal] = useUnit([$SearchStore, closeSearchEvent]);
  if (typeof animate === 'undefined') {
    animate = true;
  }
  const getModalContent = (state: TransitionStatus) => (
    <div data-state={state} className={'inset-0 fixed z-40 ' + transitionClasses[state]}>
      <div ref={nodeRef} id="ModalContainerLayout" className="fixed inset-0 z-40 bg-white opacity-80"></div>
      <SearchModalWrapper closePopUp={onClose ? onClose : closeModal} transitionStatus={state}></SearchModalWrapper>
    </div>
  );

  const duration = 200;

  const nodeRef = useRef(null);

  if (!animate) {
    return store.isShown ? getModalContent('entered') : null;
  }

  return (
    <Transition in={store.isShown} nodeRef={nodeRef} timeout={duration} unmountOnExit={true}>
      {getModalContent}
    </Transition>
  );
};
